import { UserPlus, LayoutDashboard, TrendingUp } from 'lucide-react';
import { Reveal, SectionHeading } from '../components/Reveal';

const STEPS = [
  {
    icon: <UserPlus className="h-5 w-5" />,
    title: 'Create Account & Set Up',
    copy: 'Start free, no credit card needed.',
  },
  {
    icon: <LayoutDashboard className="h-5 w-5" />,
    title: 'Set Up Workspace',
    copy: 'Customize your dashboard to match your workflow.',
  },
  {
    icon: <TrendingUp className="h-5 w-5" />,
    title: 'Grow Smarter',
    copy: 'Monitor progress, optimize performance, and watch your business.',
  },
];

export const HowItWorks = () => (
  <section className="py-20 lg:py-28" id="how-it-works" data-testid="how-it-works-section">
    <div className="container-x">
      <div className="grid gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16">
        <div>
          <SectionHeading
            eyebrow="Plan Your Process"
            title="Getting Started Is Simple"
            sub="Contact us and our professional team will design a custom AI voice agent tailored to your business needs, helping you automate conversations and capture more leads effortlessly."
          />
        </div>

        <ol className="relative space-y-5">
          <div
            className="absolute bottom-8 left-[34px] top-8 hidden w-px border-l-2 border-dashed border-brand-lineBlue sm:block"
            aria-hidden="true"
          />
          {STEPS.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.1}>
              <li className="relative flex items-start gap-5 rounded-3xl border border-brand-line bg-white p-6 shadow-card transition-all duration-300 hover:-translate-y-1 hover:shadow-lift">
                <span className="relative z-10 flex h-[46px] w-[46px] shrink-0 items-center justify-center rounded-2xl bg-brand-navy text-sm font-extrabold text-white">
                  {i + 1}
                </span>
                <div>
                  <h3 className="flex items-center gap-2 text-lg font-bold tracking-tight text-brand-navy">
                    <span className="text-brand-skyDeep">{s.icon}</span>
                    {s.title}
                  </h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-slate-600">{s.copy}</p>
                </div>
              </li>
            </Reveal>
          ))}
        </ol>
      </div>
    </div>
  </section>
);
